import React, { useEffect } from 'react';
import {
  Route,
  Routes
} from 'react-router-dom';

import Layout from './components/common/Layout';
import AuthPage from './pages/Auth';
import HomePage from './pages/Home';
import UserStore from './store/UserStore';
import PrivateLayout from './components/common/PrivateLayout';
import ProfilePage from './pages/Profile';
import { getCookie } from './utils/utils';
import AuthStore from './store/auth/AuthStore';
import AdminLayout from './components/common/AdminLayout';
import SettingsPage from './pages/Settings';
import AdminPanelPage from './pages/AdminPanel';
import AdminRatingPage from './pages/AdminRatingPage';

const App: React.FC = () => {
  useEffect(() => {
    async function getUserData() {
      if (getCookie('AccessToken')) {
        UserStore.getUserData();
      }
      else {
        await AuthStore.refresh();
      }
    }
  
    getUserData();
  });

  return (
    <>
      <Routes>
        <Route path='/' element={<Layout />}>
          <Route index element={<HomePage />} />
          <Route path='/auth' element={<AuthPage />} />
          <Route element={<PrivateLayout />}>
            <Route path='/profile' element={<ProfilePage />}/> 
            <Route path='/settings' element={<SettingsPage />}/>
          </Route>
          <Route element={<AdminLayout />}>
            <Route path='/admin' element={<AdminPanelPage />}/>
            <Route path='/rating' element={<AdminRatingPage />} />
          </Route>
          <Route path='*' element={<h1>Page not found</h1>} />
        </Route>
      </Routes>
    </>
  );
}

export default App;
